module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("ingk1"))).then(() => parcelRequire('3a9aZ'));